/**
 * 予約基本情報取得API store サービス
 *
 */
import { Injectable } from '@angular/core';
import { SupportClass } from '../../components/support-class';
import { select, Store } from '@ngrx/store';
import { AmcmemberApiService, GetBasicReservationInformationRequest } from 'src/sdk-amcmember';
import {
  GetBasicReservationInformationState,
  GetBasicReservationInformationStore,
  resetGetBasicReservationInformation,
  selectGetBasicReservationInformationState,
  setGetBasicReservationInformationFromApi,
} from '../../store';
import { ApiErrorResponseService } from '../api-error-response/api-error-response.service';
import { Observable } from 'rxjs/internal/Observable';
import { filter } from 'rxjs/operators';

/**
 * 予約基本情報取得API store サービス
 *
 * store情報
 * @param getBasicReservationInformationData @see GetBasicReservationInformationState
 */
@Injectable()
export class GetBasicReservationInformationStoreService extends SupportClass {
  private _getBasicReservationInformation$: Observable<GetBasicReservationInformationState>;
  private _getBasicReservationInformationData!: GetBasicReservationInformationState;
  get getBasicReservationInformationData() {
    return this._getBasicReservationInformationData;
  }

  constructor(
    private _store: Store<GetBasicReservationInformationStore>,
    private _api: AmcmemberApiService,
    private _apiErrorResponseService: ApiErrorResponseService
  ) {
    super();
    this._getBasicReservationInformation$ = this._store.pipe(
      select(selectGetBasicReservationInformationState),
      filter((data) => !!data)
    );
    this.subscribeService(
      'GetBasicReservationInformationStoreServiceData',
      this._getBasicReservationInformation$,
      (data) => {
        this._getBasicReservationInformationData = data;
      }
    );
  }

  destroy() {}

  public getGetBasicReservationInformation$() {
    return this._getBasicReservationInformation$;
  }

  public resetGetBasicReservationInformation() {
    this._store.dispatch(resetGetBasicReservationInformation());
  }

  public setGetBasicReservationInformationFromApi(request: GetBasicReservationInformationRequest) {
    this._apiErrorResponseService.clearApiErrorResponse(); //　エラーを事前にクリア
    this._store.dispatch(
      setGetBasicReservationInformationFromApi({ call: this._api.getBasicReservationInformationPost(request) })
    );
  }
}
